export default "__VITE_ASSET__eb6d0823__"